import { render, staticRenderFns } from "./SliderSection.vue?vue&type=template&id=0e3e6d49&scoped=true&"
import script from "./SliderSection.vue?vue&type=script&lang=js&"
export * from "./SliderSection.vue?vue&type=script&lang=js&"
import style0 from "./SliderSection.vue?vue&type=style&index=0&id=0e3e6d49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3e6d49",
  null
  
)

export default component.exports